import { menuItemClasses } from '@mui/material'
import { CSSObject } from 'tss-react'
import { gray } from '~/common/styles/colors'
import { typography } from '~/common/styles/typography'

export const menuItemPrimitives = {
  display: 'flex',
  alignItems: 'center',
  paddingInlineStart: '8px',
  paddingTop: '8px',
  paddingInlineEnd: '12px',
  paddingBottom: '8px',
  gap: '6px',
  ...typography.body1,
  [`&.${menuItemClasses.gutters}`]: {
    display: 'flex',
    alignItems: 'center',
    '&:hover, &.Mui-focused': { backgroundColor: gray[1] },
    [`&.${menuItemClasses.focusVisible}`]: {
      backgroundColor: gray[1],
    },
    [`& .${menuItemClasses.focusVisible}`]: {
      backgroundColor: gray[1],
    },
    [`&.${menuItemClasses.selected}`]: {
      backgroundColor: gray[1],
      '&:hover, &.Mui-focused': {
        backgroundColor: gray[1],
      },
    },
  },
}

export const getSelectedCheckmarkPrimitives = (isSelected: boolean): CSSObject => ({
  height: '14px',
  visibility: isSelected ? 'visible' : 'hidden',
})
